






















import { Component, Vue } from 'vue-property-decorator';

import ENV from '@/environment';

@Component({})
export default class Info extends Vue {

  content = {};
  env = ENV;

  mounted() {
    if (this.env.REGION === 'by') {
      this.content = this.contentBy;
    } else {
      this.content = this.contentRu;
    }
  }

  contentRu = {
    questions: [
      {
        question: 'Что произойдет, если минуты закончились раньше окончания срока действия Проездного?',
        answer: 'Каждая следующая минута в поездке и в ожидании будет оплачиваться отдельно.'
      },
      {
        question: 'А что, если срок действия Проездного закончился, а минуты остались?',
        answer: 'Если срок действия Проездного закончился, неиспользованные минуты сгорают.'
      },
      {
        question: 'Тоже очень важно',
        answer: 'В Проездном нет Сказки. А еще его нельзя оплатить бонусами, вернуть или обменять.'
      }
    ]
  };
  contentBy = {
    questions: [
      {
        question: 'Что произойдет, если минуты закончились раньше, чем кончится Проездной?',
        answer: 'Каждая следующая минута в поездке и в ожидании будет оплачиваться отдельно по тарифу Проездного.'
      },
      {
        question: 'А что, если срок действия Проездного закончился, а минуты остались?',
        answer: 'Неиспользованные минуты сгорают.'
      },
      {
        question: 'Можно ли воспользоваться бонусами при покупке проездного?',
        answer: 'Да. Бонусами можно оплатить до 50% стоимости.'
      },
      {
        question: 'Как формируется предложение в Проездном?',
        answer: 'Персональное предложение рассчитывается, исходя из частоты твоих поездок.',
        sub: true
      },
    ]
  };

  public psSettings = { suppressScrollX: true };
}
